module.exports = __webpack_public_path__ + "76cd3d2fbfea785bc09fab00f3bcbf11.jpg";